import BannerEnum from '../enumerators/banner.enum'

export default class BannerComponent {
    constructor() {
        BannerComponent.moreIntro()
    }

    static moreIntro() {
        if ($(BannerEnum.HEADER_INTRO_MORE_BUTTON).length > 0) {
            $(BannerEnum.HEADER_INTRO_MORE_BUTTON).on('click', () => {
                $(BannerEnum.HEADER_INTRO_MORE).show()
                $(BannerEnum.HEADER_INTRO_MORE_BUTTON).removeClass('show')
                $(BannerEnum.HEADER_INTRO_LESS_BUTTON).addClass('show')
                $(BannerEnum.HEADER_INTRO_MORE_DOTS).html('')
            })

            $(BannerEnum.HEADER_INTRO_LESS_BUTTON).on('click', () => {
                $(BannerEnum.HEADER_INTRO_MORE).hide()
                $(BannerEnum.HEADER_INTRO_MORE_BUTTON).addClass('show')
                $(BannerEnum.HEADER_INTRO_LESS_BUTTON).removeClass('show')
                $(BannerEnum.HEADER_INTRO_MORE_DOTS).html('...')
            })
        }
    }
}
